import { defer } from 'react-router-dom'

import { logger } from '$utils'

import useMenusStore from '../store'
import { isAppStateReady } from 'src/state/store'

async function createMenuLoader() {
  logger.debug(
    '[loader] About to await AppState being ready in CreateMenu loader'
  )
  await isAppStateReady()
  logger.debug('[loader] AppState should now be ready in CreateMenu loader')

  const menusStore = useMenusStore.getState()
  menusStore.initializeNewMenu()

  const recipesPromise = menusStore.getRecipes()
  const itemsPromise = menusStore.getItems()

  return defer({
    data: Promise.all([recipesPromise, itemsPromise]).then(
      ([recipes, items]) => ({
        recipes,
        items,
      })
    ),
  })
}

export default createMenuLoader
